module.exports = __webpack_public_path__ + "img/lpfv-pc.5e6f0fa8.png";